export default {
  text_one: 'Verdien {{count}} punt',
  text_other: 'Verdien {{count}} punten',
};
